import { Controller } from "@hotwired/stimulus"

const MATRIX_TYPES = ["mts", "mtm", "mtx"]
const NO_CHOICES_TYPES = ["fa", "fs", "num"]

// reading_type / question_type に応じて選択肢エリア・各種バナーの表示を切り替える。
export default class extends Controller {
  static targets = ["select", "choicesArea", "questionTypeSelect", "matrixNotice", "noChoicesNotice", "answerTypeSelect", "childChoicesArea"]

  // reading_type 変更時: 自由回答以外・かつ選択肢不要タイプ以外では選択肢エリアを表示する。
  toggle() {
    if (!this.hasChoicesAreaTarget) return
    const questionType = this.hasQuestionTypeSelectTarget ? this.questionTypeSelectTarget.value : ""
    const readingType = this.selectTarget.value
    if (MATRIX_TYPES.includes(questionType) || NO_CHOICES_TYPES.includes(questionType) || readingType === "free_answer") {
      this.choicesAreaTarget.classList.add("hidden")
    } else {
      this.choicesAreaTarget.classList.remove("hidden")
    }
  }

  // question_type 変更時: タイプに応じてバナーと選択肢エリアを切り替える。
  toggleByQuestionType() {
    const value = this.questionTypeSelectTarget.value
    const isMatrix = MATRIX_TYPES.includes(value)
    const isNoChoices = NO_CHOICES_TYPES.includes(value)
    const readingType = this.hasSelectTarget ? this.selectTarget.value : ""
    const hideChoices = isMatrix || isNoChoices || readingType === "free_answer"

    if (this.hasMatrixNoticeTarget) {
      this.matrixNoticeTarget.classList.toggle("hidden", !isMatrix)
    }

    if (this.hasNoChoicesNoticeTarget) {
      this.noChoicesNoticeTarget.classList.toggle("hidden", !isNoChoices)
    }

    if (this.hasChoicesAreaTarget) {
      this.choicesAreaTarget.classList.toggle("hidden", hideChoices)
    }
  }

  // 子設問の answer_type ( FA/NUM ) に応じて選択肢エリアの表示を切り替える。
  toggleByAnswerType() {
    const value = this.answerTypeSelectTarget.value
    if (["FA", "NUM"].includes(value)) {
      this.childChoicesAreaTarget.classList.add("hidden")
    } else {
      this.childChoicesAreaTarget.classList.remove("hidden")
    }
  }
}
